<sirius-form-feature-base [title]="title" [textHtml]="textHtml">
    <div #submitTarget></div>
    @if (formHtml) {
        <div id="embedded-form-container" #form [innerHTML]="formHtml"></div>
    }
</sirius-form-feature-base>
